import type { MarketplaceOrderHandoffDefaults } from "@nexus/contracts"

const DRAFT_PREFIX = "nexus:vendor-email-draft:"

export interface VendorEmailDraft {
  recipientsTo: string
  recipientsCc: string
  recipientsBcc: string
  subject: string
  handoffOverrideNote: string
  handoffDefaults: MarketplaceOrderHandoffDefaults
  updatedAt: string
}

export function vendorEmailDraftKey(
  tenantId: string,
  scriptIds: readonly string[],
  briefIds: readonly string[] = [],
): string {
  const scriptPart = [...scriptIds].sort().join(",")
  const briefPart = [...briefIds].sort().join(",")
  return `${DRAFT_PREFIX}${tenantId}:${scriptPart}:${briefPart}`
}

export function readVendorEmailDraft(key: string): VendorEmailDraft | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw) as VendorEmailDraft
    if (!parsed || typeof parsed !== "object") return null
    return parsed
  } catch {
    return null
  }
}

export function writeVendorEmailDraft(key: string, draft: VendorEmailDraft): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(draft))
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export function clearVendorEmailDraft(key: string): void {
  try {
    sessionStorage.removeItem(key)
  } catch {
    // Ignore.
  }
}
